<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :allowFields="$lang.search_person_fildes"
      :title="$lang.searchPerson"
      :remove_item="remove_item"
      config="person"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :dynamicButtons="buttons"
      :hiddenFields="hiddenFieldList"
      primaryKey="code"
      ref="searchPerson"
      :openNewTab="true"
      routeName="editPerson"
      :filterCatch="true"
      :defaultViewCount="10"
      :isImportExcel="false"
      :visibleAdd="false"
      :isImportExcelTooltip="$lang.infoPersonAttachFile"
      @importExcel="importExcelModal"
      @removeModalHidden="resetDeleteReason"
    >
      <template slot="addModal" slot-scope="search">
        <AddPerson
          isModal
          @modal-end-up="search.close"
          @getItems="getItems"
        ></AddPerson>
      </template>
      <template slot="removeModalOtherData">
        <b-row>
          <b-col cols="12">
            <b-form-group
              :label="$lang.profileLang.delete_reason"
              label-for="description"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.profileLang.delete_reason"
                :rules="$v.deleteReason.$params"
              />
              <b-form-textarea
                v-model="$v.deleteReason.$model"
                :placeholder="$lang.profileLang.delete_reason_placeholder"
                :rows="3"
                :state="$v.deleteReason.$dirty ? !$v.deleteReason.$error : null"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="deleteReason-feedback"
                >{{
                  $lang.error_required
                    | replace($lang.profileLang.delete_reason)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="isImportFile"
      size="xl"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          {{ $lang.person_upload_excel_form_title }}
        </div>
        <ShowCardUpload
          :url="uploadExcelUrl"
          :showAlert="exampleFileLink"
          @closeModal="isImportFile = false"
          @getItems="getItems"
        />
      </b-card>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="personModal"
      :title="$lang.add_user_role_tooltip"
      size="xl"
      hide-header
      modal-class="mehdi"
    >
      <template v-slot:modal-footer>
        <b-button variant="success">
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button variant="danger" @click="personModal = false">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddPerson from "./addPersonNew";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { required } from "vuelidate/lib/validators";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "search-person",
  components: {
    Search,
    AddPerson,
    ShowCardUpload,
  },
  validations: {
    deleteReason: {
      required,
    },
  },
  data() {
    return {
      personCode: null,
      personModal: false,
      isImportFile: false,
      hiddenFieldList: [
        "created_at",
        "created_by",
        "updated_by",
        "updated_at",
        "birth_date",
        "years_management",
        "marriage",
      ],
      fileUpload: [],
      progress: 0,
      fileInfo: {},
      loadingItem: false,
      buttons: [
        {
          id: "0",
          name: "edit",
          // click: this.openModal,
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      deleteReason: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["resources", "person"]);
    },
    uploadExcelUrl() {
      return generateApiUrl(["resources", "import_person"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_user.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  methods: {
    generateApiUrl,
    getItems() {
      this.$refs.searchPerson.getItems();
    },
    openModal(item) {
      this.personModal = true;
      this.personCode = item.code;
    },
    closeIsImportFile() {
      this.fileUpload = [];
      this.isImportFile = false;
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    removeFileProgress() {
      this.fileUpload = [];
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    getImg(file) {
      const fileType = file.type;
      const fileName = file.name.split(".")[1]; // get file by suffix name
      return fileType.match("image")
        ? URL.createObjectURL(file)
        : `/img/shared/file-icon/${fileName}.svg`;
    },
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
      this.fileInfo = this.fileUpload[this.fileUpload.length - 1];
    },
    importExcelModal() {
      this.isImportFile = true;
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    remove_item(item) {
      this.$v.$touch();
      if (this.$v.$anyError) {
        /* guidance: stop process for required inputs */
        return "required_inputs";
      }
      const deleted_reason = this.deleteReason;
      return this.$httpService
        .delete(this.url + "/" + item.code, { deleted_reason })
        .then((response) => {
          this.$notify.success(response.data.message);
          this.deleteReason = null;
          return true;
        })
        .catch((error) => {
          this.$generateError(error);
          this.deleteReason = null;
          throw "error";
        });
    },
    resetDeleteReason() {
      this.deleteReason = null;
      this.$v.deleteReason.$reset();
    },
  },
};
</script>

<style>
.preview_file > .flex-row > img {
  width: 100px !important;
}
</style>
